
export function applyFiltersToUI(ctx) {
    const { categorySelect, subcategorySelect, formatFilter, searchInput } = ctx.filterElements || {};

    if (categorySelect && ctx.activeFilters.category) {
        categorySelect.value = ctx.activeFilters.category;
        ctx.updateSubcategoryOptions();
    }

    if (subcategorySelect && ctx.activeFilters.subcategory) {
        subcategorySelect.value = ctx.activeFilters.subcategory;
    }

    if (formatFilter && ctx.activeFilters.format) {
        formatFilter.value = ctx.activeFilters.format;
    }

    if (searchInput && ctx.activeFilters.search) {
        searchInput.value = ctx.activeFilters.search;
    }
    
    // Apply public only filter checkbox state
    const publicOnlyCheckbox = document.getElementById('public-only-filter');
    if (publicOnlyCheckbox && ctx.activeFilters.publicOnly !== undefined) {
        publicOnlyCheckbox.checked = !!ctx.activeFilters.publicOnly;
    }
}


